import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react'
import { useUser } from '../../utils/userContext';
import { toast, ToastContainer } from 'react-toastify';
import useHandleErrors from '../../utils/user.utils';
import { utils, write } from 'xlsx';
import { saveAs } from 'file-saver';


const Leavereport = () => {
    const [leaves, setLeaves] = useState([]);
    const { user } = useUser();
    const [loading, setLoading] = useState(false);
    const handleErrors = useHandleErrors();
    const token = localStorage.getItem("token");
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const hasFetchedRef = useRef(false);

    const getLeaveStatus = async () => {
        setLoading(true)
        if (user && user.OfficialEmail) {
            try {
                const path = `/LeaveTracker/summary`;
                const URL = process.env.REACT_APP_BE_URL + path;
                const response = await axios.get(URL, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                });
                if (response.status === 200) {
                    console.log("response", response.data)
                    const responseData = response.data || [];
                    setLeaves(responseData);
                    setFilteredData(responseData);
                }
                else {
                    handleErrors(response);
                }
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 404) {
                        // Handle 404 status code separately
                        setLeaves([]);
                        setFilteredData([]);
                    } else {
                        handleErrors(error.response);
                    }
                } else {
                    toast.error("Something went wrong. Please try again later.", {
                        position: toast.POSITION.TOP_CENTER,
                    });
                }
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        if (!hasFetchedRef.current) {
            getLeaveStatus();
            hasFetchedRef.current = true;
        }
    }, [user]);


    const sendEmail = (email) => {
        const ws = utils.json_to_sheet(filteredData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Leaves');
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });

        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const today = new Date();
        const year = today.getFullYear().toString().slice(-2); // Get last two digits of the year
        const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Add leading 0 for month
        const day = today.getDate().toString().padStart(2, '0'); // Add leading 0 for day
        const formattedDate = `${year}${month}${day}`;
        saveAs(data, `WW360-Leave_Report_${formattedDate}.xlsx`);
    };

    const handleExport = () => {
        const ws = utils.json_to_sheet(filteredData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Assets');
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const today = new Date();
        const year = today.getFullYear().toString().slice(-2); // Get last two digits of the year
        const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Add leading 0 for month
        const day = today.getDate().toString().padStart(2, '0'); // Add leading 0 for day
        const formattedDate = `${year}${month}${day}`;
        saveAs(data, `WW360-Leave_Report_${formattedDate}.xlsx`);
    };

    const handleShare = async () => {
        try {
            await navigator.share({
                title: 'Leave List',
                text: 'Check out the Leave list',
                url: window.location.href
            });
        } catch (err) {
            console.error('Error sharing:', err);
        }
    };

    useEffect(() => {
        setFilteredData(
            leaves?.filter(data =>
                data.leaveType.toLowerCase().includes(searchQuery.toLowerCase()) ||
                data.userEmailId.toLowerCase().includes(searchQuery.toLowerCase()) ||
                data.status.toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
    }, [searchQuery, leaves]);

    const handleRecordsPerPageChange = (event) => {
        setRecordsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(filteredData.length / recordsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);


    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <ToastContainer />
            <div class="content-page">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col">
                            <h3 class="title mb-2">Leave Report</h3>
                        </div>
                        <div class="col-auto"><a href={"/SubmitTimesheet"} data-extra-toggle="tab" data-target="#timesheet-pan" class="btn btn-primary mt-lg-0 mt-4"><i class="ri-calendar-schedule-fill"></i> Timesheet</a></div>
                    </div>
                    {leaves?.length === 0 ? (
                        <div class="container">
                            <div class="row vh-50 justify-content-center align-items-center">
                                <div class="col-auto">
                                    <div class="no-data-wrapper">
                                        <div class="no-data-found">
                                            <i class="ri-file-damage-fill"></i>
                                            <div class="bounce"><i class="ri-search-eye-line"></i></div>
                                            <p>No Data Found</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div class="row align-items-center justify-content-center">
                                <div class="col-5">
                                    <div class="container-fluid row-rounded mb-0">
                                        <div class="row px-2 py-0">
                                            <div class="input-group mb-0">
                                                <input
                                                    type="search"
                                                    className="form-control search-input"
                                                    placeholder="Keyword search..."
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                />                                                        <div class="input-group-append">
                                                    <button class="btn btn-primary" type="button" title="Search" rel="tooltip"><i class="ri-menu-search-line"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <small class="form-text text-muted text-center mt-0"><i class="ri-information-2-fill text-info"></i> Allows: Email - Leave Type - Status </small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="card mb-4">
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col">
                                                    <h5 class="title mt-1 mb-0">Approval Pending</h5>
                                                </div>
                                                <div className="col-auto">
                                                    <button type="button" title="Email" className="btn btn-light btn-circle ml-2" onClick={() => sendEmail()}>
                                                        <i className="ri-mail-send-fill"></i>
                                                    </button>
                                                    <button type="button" title="Share" className="btn btn-light btn-circle ml-2" onClick={handleShare}>
                                                        <i className="ri-share-fill"></i>
                                                    </button>
                                                    <button type="button" title="Export" className="btn btn-light btn-circle ml-2" onClick={handleExport}>
                                                        <i className="ri-export-fill"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="row mt-3">
                                                <div className="col-md-12">
                                                    <div className="table-responsive leave-information">
                                                        <table className="table grid">
                                                            <thead className="bg-light">
                                                                <tr>
                                                                    <th>S.No.</th>
                                                                    <th>Employee Email</th>
                                                                    <th>Leave Type</th>
                                                                    <th>Start Date</th>
                                                                    <th>End Date</th>
                                                                    <th>Current Leave Balance</th>
                                                                    <th>Status</th>
                                                                    {/* <th></th> */}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {currentRecords?.map((leave, index) => (
                                                                    <tr key={leave.leaveId}>
                                                                        <td>{index + 1 + indexOfFirstRecord}</td>
                                                                        <td>{leave.userEmailId}</td>
                                                                        <td>{leave.leaveType}</td>
                                                                        <td>{moment(leave.startDate).format("DD-MM-YYYY")}</td>
                                                                        <td>{moment(leave.endDate).format("DD-MM-YYYY")}</td>
                                                                        <td className="text-center"><span className="text-info border badge border-info">{leave.noOfhours}</span></td>
                                                                        <td>
                                                                            <span className={`badge border text-${leave.status === 'Pending' ? 'warning' :
                                                                                leave.status === 'Approved' ? 'success' :
                                                                                    leave.status === 'Submitted' ? 'secondary' : 'danger'
                                                                                } status`}>
                                                                                <i className={`ri-${leave.status === 'Pending' ? 'hourglass-fill' :
                                                                                    leave.status === 'Approved' ? 'thumb-up-fill' :
                                                                                        leave.status === 'Submitted' ? 'thumb-up-fill' : 'thumb-down-fill'
                                                                                    }`}></i> {leave.status}
                                                                            </span>
                                                                        </td>


                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>

                                                <div className="col-md-12">
                                                    <div className="container-fluid">
                                                        <div className="row border-top pt-3">
                                                            <div className="col-auto">
                                                                <p className="mt-1 mb-0">Records</p>
                                                            </div>
                                                            <div className="col-1 record-drop">
                                                                <select className="form-control" value={recordsPerPage} onChange={handleRecordsPerPageChange}>
                                                                    <option value="5">5</option>
                                                                    <option value="10">10</option>
                                                                    <option value="15">15</option>
                                                                    <option value="20">20</option>
                                                                    <option value="25">25</option>
                                                                </select>
                                                            </div>
                                                            <div className="col">
                                                                <nav>
                                                                    <ul className="pagination justify-content-center">
                                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(1)} tabIndex="-1">
                                                                                <i className="ri-arrow-left-double-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(currentPage - 1)} tabIndex="-1">
                                                                                <i className="ri-arrow-left-s-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        {Array.from({ length: totalPages }, (_, index) => (
                                                                            <li key={index + 1} className={`page-item ${index + 1 === currentPage ? 'active' : ''}`}>
                                                                                <button className="page-link" onClick={() => paginate(index + 1)}>
                                                                                    {index + 1}
                                                                                </button>
                                                                            </li>
                                                                        ))}
                                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(currentPage + 1)}>
                                                                                <i className="ri-arrow-right-s-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(totalPages)}>
                                                                                <i className="ri-arrow-right-double-fill"></i>
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                </nav>
                                                            </div>
                                                            <div className="col-auto">
                                                                <p className="mt-1 mb-0">Page Showing {currentPage} of {totalPages}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </div>
    )
}

export default Leavereport
